import { servita } from "../data/procesiones/servita";
import { lapaz } from "../data/procesiones/lapaz";
import { laspenas } from "../data/procesiones/laspenas";
import { despojado } from "../data/procesiones/despojado";
import { sagradacena } from "../data/procesiones/sagradacena";
import { humildadypaciencia } from "../data/procesiones/humildadypaciencia";
import { nazarenodelamor } from "../data/procesiones/nazarenodelamor";
import { prendimiento } from "../data/procesiones/prendimiento";
import { lapalma } from "../data/procesiones/lapalma";
import { veracruz } from "../data/procesiones/veracruz";
import { sanidad } from "../data/procesiones/sanidad";
import { piedad } from "../data/procesiones/piedad";
import { caído } from "../data/procesiones/caído";
import { columna } from "../data/procesiones/columna";
import { eccehomo } from "../data/procesiones/eccehomo";
import { lasaguas } from "../data/procesiones/lasaguas";
import { sentencia } from "../data/procesiones/sentencia";
import { cigarreras } from "../data/procesiones/cigarreras";
import { angustias } from "../data/procesiones/angustias";
import { afligidos } from "../data/procesiones/afligidos";
import { oraciónenelhuerto } from "../data/procesiones/oraciónenelhuerto";
import { nazareno } from "../data/procesiones/nazareno";
import { medinaceli } from "../data/procesiones/medinaceli";
import { descendimiento } from "../data/procesiones/descendimiento";
import { elperdón } from "../data/procesiones/elperdón";
import { sietepalabras } from "../data/procesiones/sietepalabras";
import { expiración } from "../data/procesiones/expiración";
import { buenamuerte } from "../data/procesiones/buenamuerte";
import { eccematertua } from "../data/procesiones/eccematertua";
import { soledad } from "../data/procesiones/soledad";
import { resucitado } from "../data/procesiones/resucitado";

export const procesiones = {
	servita,
	lapaz,
	laspenas,
	despojado,
	sagradacena,
	humildadypaciencia,
	nazarenodelamor,
	prendimiento,
	lapalma,
	veracruz,
	sanidad,
	piedad,
	caído,
	columna,
	eccehomo,
	lasaguas,
	sentencia,
	cigarreras,
	angustias,
	afligidos,
	oraciónenelhuerto,
	nazareno,
	medinaceli,
	descendimiento,
	elperdón,
	sietepalabras,
	expiración,
	buenamuerte,
	eccematertua,
	soledad,
	resucitado
};



// WEBPACK FOOTER //
// ./src/data/procesiones.js